module.exports = __webpack_public_path__ + "img/discover.223fb9dc.png";